import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import DrawerCustom from '../../components/DrawerCustom'
import { Grid, ListItem, InputBase, List, ListItemText } from '@material-ui/core';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker'
import { LeftIcon,FavoriteActiveIcon, FavoriteIcon, GiftIcon } from '../../components/icons';
import Container from '../../components/Container';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import Divider from '../../components/Divider';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getAppCfg } from '../../utils/common';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import ModalAlert from '../../components/ModalAlert';

const containerStyle = {
    width: '100%',
    height: '100%'
};
const styles = theme => ({
    map: {
        width: '100%',
        height: '100%'
    },
    footer: {
        height: 360,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        backgroundColor: theme.palette.background.secondary,
        borderTopLeftRadius: theme.spacing(4),
        borderTopRightRadius: theme.spacing(4),
        padding: theme.spacing(4)
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        left: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    search_list: {
        backgroundColor: theme.palette.background.secondary,
        width: '90%',
        position: 'absolute',
        top: theme.spacing(10),
        borderBottomLeftRadius: theme.spacing(3),
        borderBottomRightRadius: theme.spacing(3),
        zIndex: 999
    },
    item_image: {
        width: 48,
        height: 48,
        borderRadius: 48
    },
    item_icon: {
        width: 48,
        height: 48,
        borderRadius: 48,
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        justifyContent: 'center',
        alignItems: 'center'
    }
})
function OrderMerchantsView(props) {
    const [markerSelected, onSelectMaker] = useState(null);

    const { open, onClose, stores, initialRegion, classes,order_favourite_shop } = props;
    const app_config = getAppCfg()
    var featuresOrder = app_config && app_config.features && app_config.features.ordering_details ? app_config.features.ordering_details : null; 
    console.log("stores:", stores);
    return (
        <Container showLoading={props.showLoading}>
            <DrawerCustom
                large
                open={open}
                onClose={onClose}
                fullScreen>
                <Grid xs={12} item className={classes.map}>
                    <GoogleMapComponent>
                        {stores ? stores.map((marker, index) => {
                            {/* var location = marker.location; */ }
                            var location = marker.address;
                            if (location && location.lat && location.lon) {
                                return (<GoogleMapMarker key={index}
                                    info={{ title: marker.name, description: location.address_line_1, id: marker.id }}
                                    lat={location.lat}
                                    lng={location.lon}
                                    onClick={onSelectMaker}
                                    markerSelected={markerSelected}
                                    onSelect={() => props.onSelectMerchant(marker)} />)
                            }
                        }) : null}
                    </GoogleMapComponent>
                    <Grid color='gray' className={classes.buttonBack} onClick={props.onClose}>
                        <LeftIcon />
                    </Grid>
                </Grid>
                <Grid item className={classes.footer}>
                    <CustomTypo variant='subtitle2'>{t('locations')}</CustomTypo>
                    <Divider fullWidth />
                    <InfiniteScroll
                        dataLength={stores.length} //This is important field to render the next data
                        height={300}
                    >
                        <Grid xs={12} item container>
                            {stores.map((item, index) => (
                                <MerchantItem order_favourite_shop={order_favourite_shop} classes={classes}
                                    item={item} index={index} onSelectMerchant={props.onSelectMerchant} 
                                    addFavouriteShop={props.addFavouriteShop}
                                    isShowFavourite={featuresOrder && featuresOrder.preferred_organisation_orders ? featuresOrder.preferred_organisation_orders : false}
                                />
                            ))}</Grid>
                    </InfiniteScroll>
                </Grid>
            </DrawerCustom>
            {props.message && <ModalAlert
                open={props.message.show}
                onClose={props.showMessage}
                message={props.message.content}
            />}
        </Container>
    );
}

function MerchantItem(props) {
    var classes = props.classes
    var item = props.item;
    var isShowFavourite = props.isShowFavourite
    var order_favourite_shop = props.order_favourite_shop;
    var storeSelected = props.storeSelected;
    var distance = item.location && item.location.distance ? item.location.distance.toFixed(2) : null;
    var address = item.address ? item.address.address_line_1
        + (item.address.town_city ? ', ' + item.address.town_city : '')
        + (item.address.state_province_county ? ', ' + item.address.state_province_county : '')
        + (item.address.postal_code ? ', ' + item.address.postal_code : '')
        : ''
    if (!address) {
        address = item.location.address
    }
    var covertToKM = 0;
    if (distance)
        covertToKM = distance * 1.6;
    if (covertToKM)
        covertToKM = covertToKM.toFixed(2);
    return (
        <Grid xs={12} item onClick={() => !isShowFavourite?props.onSelectMerchant(item):undefined} style={{ cursor: 'pointer' }}>
            <ListItem>
                <Grid item xs ={1} container justify='center'>
                    <MerchantItemImage image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_map_merchant)} classes={classes}/>
                </Grid>
                <Grid item xs={10} onClick={() => props.onSelectMerchant(item)} style={{ cursor: 'pointer' }}>
                    <CustomTypo variant='subtitle2'>{item.name}</CustomTypo>
                    {address ? <CustomTypo variant='body1'>{address}</CustomTypo> : null}
                    {distance &&
                        <Grid item style={{ flexDirection: 'row', marginTop: 8, alignItems: "center" }}>
                            {/* <DirectionWalkIcon /> */}
                            <CustomTypo>{covertToKM} km ({distance} ml)</CustomTypo>
                        </Grid>
                    }
                </Grid>
                {isShowFavourite&&<Grid item xs={1} onClick={() => props.addFavouriteShop(item)} style={{ cursor: 'pointer' }}>
                    {order_favourite_shop && order_favourite_shop.id == item.id ? <FavoriteActiveIcon/> : <FavoriteIcon/>}
                </Grid>}
            </ListItem>
            <Divider fullWidth />
        </Grid>
    )
}
function MerchantItemImage(props) {
    var image = props.image;
    var classes = props.classes
    if (image) {
        return <img src={image.url} className={classes.item_image} />
    } else {
        return <GiftIcon />
    }
}
export default withStyles(styles)(withTranslation()(OrderMerchantsView));